async function openMinicart() {
    const minicart = document.getElementById("minicart");
    const overlay = document.getElementById("menu-vardo-overlay");
    minicart.classList.add("active");
    overlay.classList.add("active");
    document.documentElement.classList.add("no-scroll");
    await updateMinicart(); // solo aquí
}

function closeMinicart() {
    const minicart = document.getElementById("minicart");
    const overlay = document.getElementById("menu-vardo-overlay");
    overlay.classList.remove("active");
    minicart.classList.remove("active");
    document.documentElement.classList.remove("no-scroll");
}

async function addToCartAndOpenMinicart(variantId, quantity = 1) {
    const emptyCart = document.getElementById("drawer__inner-empty");

    try {
        const requestBody = { id: variantId, quantity };

        const preorderInput = document.getElementById("preorder-label");
        if (preorderInput && preorderInput.value) {
            requestBody.properties = { "Pre-order item": preorderInput.value };
        }

        const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
        });

        if (emptyCart) emptyCart.style.display = "none";

        if (!res.ok)
            throw new Error("No se pudo agregar el producto al carrito");

        openMinicart();
    } catch (error) {
        console.error("Error al agregar al carrito:", error);
        alert("Hubo un problema al agregar el producto al carrito.");
    }
}

async function updateMinicart() {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    const itemsContainer = document.getElementById("cart-items-container");
    const subtotalContainer = document.getElementById("minicart-subtotal");
    const totalContainer = document.getElementById("totals__cart-value");
    const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: cart.currency,
    });

    const shippingContainer = document.getElementById("totals__shipping-value");
    const subtotalEl = document.getElementById("totals__total-value");
    const buttonCheckout = document.getElementById("checkout_minicart");
    const emptyCart = document.getElementById("minicart-empty");

    // Subtotal
    const subtotalMXN = cart.items_subtotal_price / 100;
    const shippingCost = subtotalMXN >= 1500 ? 0 : 150;
    const totalMXN = subtotalMXN + shippingCost;

    if (subtotalContainer)
        subtotalContainer.textContent = formatter.format(subtotalMXN);
    if (totalContainer) totalContainer.textContent = formatter.format(totalMXN);
    if (subtotalEl) subtotalEl.textContent = formatter.format(totalMXN);

    if (shippingContainer)
        shippingContainer.textContent =
            shippingCost === 0 ? "Gratis" : formatter.format(shippingCost);

    if (buttonCheckout) buttonCheckout.disabled = cart.item_count === 0;
    if (emptyCart)
        emptyCart.style.display = cart.item_count === 0 ? "flex" : "none";

    itemsContainer.innerHTML = "";

    window.PRODUCT_VARIANTS = window.PRODUCT_VARIANTS || {};

    cart.items.forEach(async (item) => {
        if (!window.PRODUCT_VARIANTS[item.variant_id]) {
            // 1. Descargar JSON
            const productJson = await fetch(`/products/${item.handle}.js`).then(
                (r) => r.json(),
            );

            // 2. Guardar todas las variantes en memoria global
            productJson.variants.forEach((v) => {
                window.PRODUCT_VARIANTS[v.id] = {
                    price: v.price,
                    compare_at_price: v.compare_at_price,
                };
            });
        }

        const vData = window.PRODUCT_VARIANTS[item.variant_id];

        const regularPrice = vData.price; // precio real
        const compareAt = vData.compare_at_price;

        let optionsHtml = "";
        item.options_with_values.forEach((option) => {
            optionsHtml += `
                <div class="product-option">
                    <p>${option.name}</p>
                    <p>${option.value}</p>
                </div>
            `;
        });

        let priceHtml = "";

        if (compareAt > regularPrice) {
            priceHtml = `
                <div class="cart-price-wrapper">
                    <span class="price price--end compare-price">
                        ${formatter.format(compareAt / 100)}
                    </span>
                    <span class="price price--end minicart-js">
                        ${formatter.format(regularPrice / 100)}
                    </span>
                </div>
            `;
        } else {
            priceHtml = `
                <span class="price price--end minicart-js">
                    ${formatter.format(regularPrice / 100)}
                </span>
            `;
        }

        let unitPriceHtml = "";
        if (item.unit_price_measurement) {
            unitPriceHtml = `
                <div class="unit-price caption">
                    ${formatter.format(item.unit_price / 100)}
                    /${
                        item.unit_price_measurement.reference_value != 1
                            ? item.unit_price_measurement.reference_value
                            : ""
                    }${item.unit_price_measurement.reference_unit}
                </div>
            `;
        }

        const quantityHtml = `
            <td class="cart-item__quantity">
                <div class="cart-item__quantity-wrapper">
                    <button type="button"
                        class="quantity__button"
                        data-item-key="${item.key}"
                        data-action="minus"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" 
                            class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z"
                                fill="currentColor"></path>
                        </svg>
                    </button>
                    <input
                        type="number"
                        name="updates[]"
                        value="${item.quantity}"
                        readonly
                        class="quantity__input"
                    >
                    <button type="button"
                        class="quantity__button"
                        data-item-key="${item.key}"
                        data-action="plus"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
                            class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"
                                fill="currentColor"></path>
                        </svg>
                    </button>
                </div>

                <button type="button"
                    class="remove-item-btn"
                    data-item-key="${item.key}"
                    aria-label="Eliminar"
                    data-action="remove"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                        class="icon icon-remove">
                        <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1z"
                            fill="currentColor"/>
                        <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z"
                            fill="currentColor"/>
                    </svg>
                </button>
            </td>
        `;

        const html = `
            <tr class="cart-item">
                <td class="cart-item__media">
                    <a href="${item.url}" class="cart-item__link" aria-hidden="true" tabindex="-1"></a>
                    <div class="cart-item__image-container gradient global-media-settings">
                        <img src="${item.image}" alt="${item.title}" loading="lazy" width="150">
                    </div>
                </td>
                <td class="cart-item__details">
                    <a href="${item.url}" class="cart-item__name h4 break">${item.product_title}</a>
                    <dl>${optionsHtml}</dl>
                </td>
                <td class="cart-item__totals right">
                    <div class="cart-item__price-wrapper">
                        ${priceHtml}
                        ${unitPriceHtml}
                    </div>
                </td>
                ${quantityHtml}
            </tr>
        `;

        itemsContainer.innerHTML += html;
    });

    actualizarBarraDeProgreso();
}

async function handleQuantityClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const itemKey = e.currentTarget.getAttribute("data-item-key");
    const action = e.currentTarget.getAttribute("data-action");

    const input =
        e.currentTarget.parentElement.querySelector(".quantity__input");
    let newQuantity = parseInt(input.value);

    if (action === "plus") newQuantity++;
    else if (action === "minus") newQuantity = Math.max(newQuantity - 1, 0);

    try {
        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
        });

        await updateMinicart();
    } catch (error) {
        console.error("Error al actualizar cantidad:", error);
    }
}

async function handleRemoveItemClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const itemKey = e.currentTarget.getAttribute("data-item-key");

    try {
        const res = await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: itemKey, quantity: 0 }),
        });

        if (!res.ok) throw new Error("No se pueden agregar más a tu carrito");

        await updateMinicart();
    } catch (error) {
        console.error("Error al eliminar ítem:", error);
    }
}

function actualizarBarraDeProgreso() {
    fetch("/cart.js")
        .then((response) => response.json())
        .then((data) => {
            const totalCart = Math.round(data.total_price / 100);
            const objetivo = 1500;
            let porcentaje = (totalCart / objetivo) * 100;
            porcentaje = Math.max(0, Math.min(porcentaje, 100));

            const barraDeProgreso = document.getElementById("barra-progreso");
            const messageBar = document.getElementById("message-bar");
            const faltante = Math.max(0, objetivo - totalCart);

            const formatter = new Intl.NumberFormat("es-MX", {
                style: "currency",
                currency: "MXN",
            });

            barraDeProgreso.style.transition = "width 0.5s ease-in-out";
            barraDeProgreso.style.width = porcentaje + "%";

            if (porcentaje >= 100) {
                messageBar.innerHTML =
                    "¡Conseguiste el envío <span>GRATIS</span>!";
            } else {
                messageBar.innerHTML = `Estás a ${formatter.format(
                    faltante,
                )} de obtener el <span>envío gratis</span>`;
            }
        })
        .catch((error) => {
            console.error("Error al actualizar la barra de progreso:", error);
        });
}
const minicartOpenButtons = document.getElementById("minicart-booster-btn");

function closeBoostMinicart() {
    const boostMinicart = document.getElementById("minicart-boost");
    boostMinicart.classList.add("boost-hidden");
    minicartOpenButtons.classList.remove("footer-cart-arrow-close");
}

function openBoostMinicart() {
    const boostMinicart = document.getElementById("minicart-boost");
    boostMinicart.classList.remove("boost-hidden");
    minicartOpenButtons.classList.add("footer-cart-arrow-close");
}

minicartOpenButtons.addEventListener("click", function (event) {
    const boostMinicart = document.getElementById("minicart-boost");
    if (boostMinicart.classList.contains("boost-hidden")) {
        openBoostMinicart();
    } else {
        closeBoostMinicart();
    }
});

document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeMinicart();
});

const overlay = document.getElementById("menu-vardo-overlay");
overlay.addEventListener("click", function (event) {
    closeMinicart();
    closeMenuVardo();
});

document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".quantity__button, .remove-item-btn");
    if (!btn) return;

    const itemKey = btn.dataset.itemKey;
    const action = btn.dataset.action;

    btn.disabled = true;
    btn.classList.add("loading");
    const originalHTML = btn.innerHTML;
    btn.innerHTML = `<span class="spinner"></span>`;

    try {
        let payload = { id: itemKey };

        if (action === "plus" || action === "minus") {
            const input = btn.parentElement.querySelector(".quantity__input");
            let newQty = parseInt(input.value);

            if (action === "plus") newQty++;
            if (action === "minus") newQty = Math.max(0, newQty - 1);

            payload.quantity = newQty;
        }

        if (action === "remove") payload.quantity = 0;

        await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        await updateMinicart();
    } catch (error) {
        console.error("Error al actualizar:", error);
    } finally {
        btn.disabled = false;
        btn.classList.remove("loading");
        btn.innerHTML = originalHTML;
    }
});

document.addEventListener("click", async (e) => {
    const button = e.target.closest(
        ".cart-container-product-button-add-to-cart",
    );
    if (!button) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const defaultLabel =
        button.dataset.defaultLabel || button.textContent.trim();

    try {
        button.disabled = true;
        button.classList.remove("is-added");
        button.classList.add("is-loading");

        button.innerHTML = `
            <span class="btn-content">
                <span class="btn-spinner" aria-hidden="true"></span>
            </span>
        `;

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
            }),
        });

        if (!response.ok) {
            throw new Error("Error al agregar al carrito");
        }

        await response.json();
        await updateMinicart();

        document.dispatchEvent(new CustomEvent("cart:refresh"));

        button.classList.remove("is-loading");
        button.classList.add("is-added");

        button.innerHTML = `
            <span class="btn-content">
                <span class="btn-check" aria-hidden="true">
                    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.4 11.2 3.7 8.5 2.6 9.6 6.4 13.4 13.4 6.4 12.3 5.3 6.4 11.2Z" fill="currentColor"/>
                    </svg>
                </span>
                <span>Agregado</span>
            </span>
        `;
    } catch (error) {
        console.error(error);
        button.classList.remove("is-loading", "is-added");
        button.textContent = "Error";
    } finally {
        setTimeout(() => {
            button.disabled = false;
            button.classList.remove("is-loading", "is-added");
            button.innerHTML = defaultLabel;
        }, 1500);
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const swatches = document.querySelectorAll(".swatch-button-minicart");

    swatches.forEach((button) => {
        button.addEventListener("click", function () {
            const image = this.dataset.image;
            const gridProduct = this.closest(".grid-product");
            const bg = gridProduct.querySelector(".grid-product-content");

            // Cambia la imagen de fondo
            if (image && bg) {
                bg.style.backgroundImage = `url('${image}')`;
            }

            // Quita .active de todos los botones del mismo grupo
            const group = this.closest("fieldset");
            group.querySelectorAll(".swatch-button-minicart").forEach((btn) => {
                btn.classList.remove("active");
            });

            // Agrega .active al botón clicado
            this.classList.add("active");
        });
    });

    // Seleccionar automáticamente el primer swatch de cada grupo si no hay ninguno activo
    const fieldsets = document.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset) => {
        const active = fieldset.querySelector(".swatch-button-minicart.active");
        if (!active) {
            const first = fieldset.querySelector(".swatch-button-minicart");
            if (first) {
                first.classList.add("active");
                const image = first.dataset.image;
                const gridProduct = first.closest(".grid-product");
                const bg = gridProduct.querySelector(".grid-product-content");
                if (image && bg) {
                    bg.style.backgroundImage = `url('${image}')`;
                }
            }
        }
    });
});

(function () {
    const COUNTDOWN_TIME = 15 * 60; // 15 minutos en segundos
    const STORAGE_KEY = "vardo_minicart_countdown_end";
    const container = document.getElementById("minicart-countdown");
    const timerEl = document.getElementById("countdown-timer");

    if (!container || !timerEl) return;

    let endTime = localStorage.getItem(STORAGE_KEY);

    if (!endTime) {
        endTime = Date.now() + COUNTDOWN_TIME * 1000;
        localStorage.setItem(STORAGE_KEY, endTime);
    } else {
        endTime = parseInt(endTime, 10);
    }

    function updateCountdown() {
        const now = Date.now();
        const remaining = Math.floor((endTime - now) / 1000);

        if (remaining <= 0) {
            container.style.display = "none";
            localStorage.removeItem(STORAGE_KEY);
            return;
        }

        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;

        timerEl.textContent = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
})();

document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(
        ".cart-container-products-boost-list",
    );
    const leftBtn = document.querySelector(".boost-arrow-left");
    const rightBtn = document.querySelector(".boost-arrow-right");

    if (!container || !leftBtn || !rightBtn) return;

    const scrollAmount = 250;

    leftBtn.addEventListener("click", () => {
        container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });

    rightBtn.addEventListener("click", () => {
        container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });

    function updateArrows() {
        const scrollLeft = container.scrollLeft;
        const maxScroll = container.scrollWidth - container.clientWidth;

        if (scrollLeft <= 5) {
            leftBtn.classList.add("hidden");
        } else {
            leftBtn.classList.remove("hidden");
        }

        if (scrollLeft >= maxScroll - 5) {
            rightBtn.classList.add("hidden");
        } else {
            rightBtn.classList.remove("hidden");
        }
    }

    container.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    // inicial
    updateArrows();
});
